var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOrganicEggOutline = function SvgOrganicEggOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 635 866",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M411.191 14.854C232.846-33.603 164.604 50.386 71.728 183.833-36.096 338.757 11.435 574.287 11.435 700.089c0 125.803 290.064 225.513 505.902 121.454 172.67-83.247 102.599-368.71 102.599-368.71s-30.4-389.522-208.745-437.979Z",
    stroke: "#CDAA96",
    strokeWidth: 2
  })));
};
export default SvgOrganicEggOutline;